import { Observable } from 'rxjs';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpAppInterceptorService } from './http.app.interceptor.service';

@Injectable()
export class HttpAppInterceptor implements HttpInterceptor {
  constructor(private httpAppInterceptorService: HttpAppInterceptorService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.httpAppInterceptorService.handleInterception(request, next);
  }
}
